import { render, staticRenderFns } from "./fw-table.vue?vue&type=template&id=440af714&scoped=true&"
import script from "./fw-table.vue?vue&type=script&lang=js&"
export * from "./fw-table.vue?vue&type=script&lang=js&"
import style0 from "./fw-table.vue?vue&type=style&index=0&id=440af714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440af714",
  null
  
)

export default component.exports